var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 1C6.13614 1 3.44855 3.44071 2.06244 5.07034C1.35066 5.90716 1.35066 7.09284 2.06244 7.92966C3.44855 9.55929 6.13613 12 9.8 12C13.4639 12 16.1514 9.55929 17.5376 7.92966C18.2493 7.09284 18.2493 5.90716 17.5376 5.07034C16.1514 3.44071 13.4639 1 9.8 1Z",
    stroke: "#696969",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0553 3.48337C9.33121 3.39859 9.61901 3.33984 9.92392 3.33984C11.5667 3.33984 12.8986 4.67176 12.8986 6.31454C12.8986 7.95732 11.5667 9.28924 9.92392 9.28924C8.28114 9.28924 6.94922 7.95732 6.94922 6.31454C6.94922 6.01038 7.00722 5.72258 7.09275 5.44593C7.23384 4.93666 7.82389 3.83117 9.0553 3.48337Z",
    stroke: "#696969",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.15fba1bf40c625d07d4ee2bf5af5e543.svg";
export { ForwardRef as ReactComponent };